/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as VendorRouteRouteImport } from './routes/vendor/route'
import { Route as LegalRouteRouteImport } from './routes/legal/route'
import { Route as CentralRouteRouteImport } from './routes/central/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorIndexRouteImport } from './routes/vendor/index'
import { Route as CentralIndexRouteImport } from './routes/central/index'
import { Route as VendorTeamRouteImport } from './routes/vendor/team'
import { Route as VendorSubscriptionRouteImport } from './routes/vendor/subscription'
import { Route as VendorSetupRouteImport } from './routes/vendor/setup'
import { Route as VendorPaymentSuccessRouteImport } from './routes/vendor/payment-success'
import { Route as VendorPagesRouteImport } from './routes/vendor/pages'
import { Route as VendorOrdersRouteImport } from './routes/vendor/orders'
import { Route as VendorNoActivePlanRouteImport } from './routes/vendor/no-active-plan'
import { Route as VendorLabelsRouteImport } from './routes/vendor/labels'
import { Route as VendorCustomFieldsRouteImport } from './routes/vendor/custom-fields'
import { Route as VendorContactGroupsRouteImport } from './routes/vendor/contact-groups'
import { Route as VendorConnectionsRouteImport } from './routes/vendor/connections'
import { Route as VendorConnectionTestRouteImport } from './routes/vendor/connection-test'
import { Route as VendorChatRouteImport } from './routes/vendor/chat'
import { Route as VendorCatalogRouteImport } from './routes/vendor/catalog'
import { Route as PageSlugRouteImport } from './routes/page.$slug'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalDataDeletionRouteImport } from './routes/legal/data-deletion'
import { Route as DeletionStatusCodeRouteImport } from './routes/deletion-status.$code'
import { Route as CentralWhatsappWebhookHealthRouteImport } from './routes/central/whatsapp-webhook-health'
import { Route as CentralVendorsRouteImport } from './routes/central/vendors'
import { Route as CentralTranslationsRouteImport } from './routes/central/translations'
import { Route as CentralSubscriptionsRouteImport } from './routes/central/subscriptions'
import { Route as CentralSubscriptionPlansRouteImport } from './routes/central/subscription-plans'
import { Route as CentralManualSubscriptionsRouteImport } from './routes/central/manual-subscriptions'
import { Route as CentralLanguagesRouteImport } from './routes/central/languages'
import { Route as CentralInstagramWebhookHealthRouteImport } from './routes/central/instagram-webhook-health'
import { Route as CentralFacebookWebhookHealthRouteImport } from './routes/central/facebook-webhook-health'
import { Route as CentralDataDeletionRouteImport } from './routes/central/data-deletion'
import { Route as CentralConfigurationRouteImport } from './routes/central/configuration'
import { Route as CentralCmsPagesRouteImport } from './routes/central/cms-pages'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthProfileRouteImport } from './routes/auth/profile'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as VendorTemplatesIndexRouteImport } from './routes/vendor/templates.index'
import { Route as VendorTeamIndexRouteImport } from './routes/vendor/team.index'
import { Route as VendorSettingsIndexRouteImport } from './routes/vendor/settings.index'
import { Route as VendorMediaIndexRouteImport } from './routes/vendor/media.index'
import { Route as VendorFormsIndexRouteImport } from './routes/vendor/forms.index'
import { Route as VendorContactsIndexRouteImport } from './routes/vendor/contacts.index'
import { Route as VendorCampaignsIndexRouteImport } from './routes/vendor/campaigns.index'
import { Route as CentralVendorsIndexRouteImport } from './routes/central/vendors.index'
import { Route as CentralCmsPagesIndexRouteImport } from './routes/central/cms-pages.index'
import { Route as VendorTemplatesNewRouteImport } from './routes/vendor/templates.new'
import { Route as VendorTemplatesNameRouteImport } from './routes/vendor/templates.$name'
import { Route as VendorSettingsRoutingRouteImport } from './routes/vendor/settings.routing'
import { Route as VendorSettingsGeneralRouteImport } from './routes/vendor/settings.general'
import { Route as VendorSettingsFeaturesRouteImport } from './routes/vendor/settings.features'
import { Route as VendorSettingsAiAndTimingRouteImport } from './routes/vendor/settings.ai-and-timing'
import { Route as VendorPagesPageIdRouteImport } from './routes/vendor/pages.$pageId'
import { Route as VendorIntegrationsMetaRouteImport } from './routes/vendor/integrations.meta'
import { Route as VendorIntegrationsGoogleRouteImport } from './routes/vendor/integrations.google'
import { Route as VendorIntegrationsEcommerceRouteImport } from './routes/vendor/integrations.ecommerce'
import { Route as VendorIntegrationsConnectedAppsRouteImport } from './routes/vendor/integrations.connected-apps'
import { Route as VendorIntegrationsApiRouteImport } from './routes/vendor/integrations.api'
import { Route as VendorInstagramSettingsRouteImport } from './routes/vendor/instagram.settings'
import { Route as VendorInstagramInboxRouteImport } from './routes/vendor/instagram.inbox'
import { Route as VendorInstagramAutomationsRouteImport } from './routes/vendor/instagram.automations'
import { Route as VendorGoogleReviewsRouteImport } from './routes/vendor/google.reviews'
import { Route as VendorFormsUidRouteImport } from './routes/vendor/forms.$uid'
import { Route as VendorFacebookInboxRouteImport } from './routes/vendor/facebook.inbox'
import { Route as VendorContactsImportRouteImport } from './routes/vendor/contacts.import'
import { Route as VendorContactsCrmRouteImport } from './routes/vendor/contacts.crm'
import { Route as VendorContactsAutoLabelsRouteImport } from './routes/vendor/contacts.auto-labels'
import { Route as VendorContactsUidRouteImport } from './routes/vendor/contacts.$uid'
import { Route as VendorCampaignsSuppressionRouteImport } from './routes/vendor/campaigns.suppression'
import { Route as VendorCampaignsNewRouteImport } from './routes/vendor/campaigns.new'
import { Route as CentralVendorsUidRouteImport } from './routes/central/vendors.$uid'
import { Route as CentralCmsPagesUidRouteImport } from './routes/central/cms-pages.$uid'
import { Route as AuthInviteTokenRouteImport } from './routes/auth/invite.$token'
import { Route as VendorSettingsAiAgentsIndexRouteImport } from './routes/vendor/settings.ai-agents.index'
import { Route as VendorInstagramTemplatesIndexRouteImport } from './routes/vendor/instagram.templates.index'
import { Route as VendorFacebookTemplatesIndexRouteImport } from './routes/vendor/facebook.templates.index'
import { Route as VendorBotsRepliesIndexRouteImport } from './routes/vendor/bots.replies.index'
import { Route as VendorBotsFlowsIndexRouteImport } from './routes/vendor/bots.flows.index'
import { Route as VendorTemplatesNameEditRouteImport } from './routes/vendor/templates.$name.edit'
import { Route as VendorSettingsAiAgentsAgentIdRouteImport } from './routes/vendor/settings.ai-agents.$agentId'
import { Route as VendorInstagramTemplatesNewRouteImport } from './routes/vendor/instagram.templates.new'
import { Route as VendorFacebookTemplatesNewRouteImport } from './routes/vendor/facebook.templates.new'
import { Route as VendorCampaignsUidStatusRouteImport } from './routes/vendor/campaigns.$uid.status'
import { Route as VendorCampaignsUidEditRouteImport } from './routes/vendor/campaigns.$uid.edit'
import { Route as VendorInstagramTemplatesUidEditRouteImport } from './routes/vendor/instagram.templates.$uid.edit'
import { Route as VendorFacebookTemplatesUidEditRouteImport } from './routes/vendor/facebook.templates.$uid.edit'
import { Route as VendorBotsFlowsFlowIdBuilderRouteImport } from './routes/vendor/bots.flows.$flowId.builder'

const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorRouteRoute = VendorRouteRouteImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRouteRoute = LegalRouteRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const CentralRouteRoute = CentralRouteRouteImport.update({
  id: '/central',
  path: '/central',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorIndexRoute = VendorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const CentralIndexRoute = CentralIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CentralRouteRoute,
} as any)
const VendorTeamRoute = VendorTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSubscriptionRoute = VendorSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSetupRoute = VendorSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorPaymentSuccessRoute = VendorPaymentSuccessRouteImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorPagesRoute = VendorPagesRouteImport.update({
  id: '/pages',
  path: '/pages',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorOrdersRoute = VendorOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorNoActivePlanRoute = VendorNoActivePlanRouteImport.update({
  id: '/no-active-plan',
  path: '/no-active-plan',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorLabelsRoute = VendorLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorCustomFieldsRoute = VendorCustomFieldsRouteImport.update({
  id: '/custom-fields',
  path: '/custom-fields',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorContactGroupsRoute = VendorContactGroupsRouteImport.update({
  id: '/contact-groups',
  path: '/contact-groups',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorConnectionsRoute = VendorConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorConnectionTestRoute = VendorConnectionTestRouteImport.update({
  id: '/connection-test',
  path: '/connection-test',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorChatRoute = VendorChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorCatalogRoute = VendorCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => VendorRouteRoute,
} as any)
const PageSlugRoute = PageSlugRouteImport.update({
  id: '/page/$slug',
  path: '/page/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalRouteRoute,
} as any)
const LegalDataDeletionRoute = LegalDataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => LegalRouteRoute,
} as any)
const DeletionStatusCodeRoute = DeletionStatusCodeRouteImport.update({
  id: '/deletion-status/$code',
  path: '/deletion-status/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const CentralWhatsappWebhookHealthRoute =
  CentralWhatsappWebhookHealthRouteImport.update({
    id: '/whatsapp-webhook-health',
    path: '/whatsapp-webhook-health',
    getParentRoute: () => CentralRouteRoute,
  } as any)
const CentralVendorsRoute = CentralVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => CentralRouteRoute,
} as any)
const CentralTranslationsRoute = CentralTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => CentralRouteRoute,
} as any)
const CentralSubscriptionsRoute = CentralSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => CentralRouteRoute,
} as any)
const CentralSubscriptionPlansRoute =
  CentralSubscriptionPlansRouteImport.update({
    id: '/subscription-plans',
    path: '/subscription-plans',
    getParentRoute: () => CentralRouteRoute,
  } as any)
const CentralManualSubscriptionsRoute =
  CentralManualSubscriptionsRouteImport.update({
    id: '/manual-subscriptions',
    path: '/manual-subscriptions',
    getParentRoute: () => CentralRouteRoute,
  } as any)
const CentralLanguagesRoute = CentralLanguagesRouteImport.update({
  id: '/languages',
  path: '/languages',
  getParentRoute: () => CentralRouteRoute,
} as any)
const CentralInstagramWebhookHealthRoute =
  CentralInstagramWebhookHealthRouteImport.update({
    id: '/instagram-webhook-health',
    path: '/instagram-webhook-health',
    getParentRoute: () => CentralRouteRoute,
  } as any)
const CentralFacebookWebhookHealthRoute =
  CentralFacebookWebhookHealthRouteImport.update({
    id: '/facebook-webhook-health',
    path: '/facebook-webhook-health',
    getParentRoute: () => CentralRouteRoute,
  } as any)
const CentralDataDeletionRoute = CentralDataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => CentralRouteRoute,
} as any)
const CentralConfigurationRoute = CentralConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => CentralRouteRoute,
} as any)
const CentralCmsPagesRoute = CentralCmsPagesRouteImport.update({
  id: '/cms-pages',
  path: '/cms-pages',
  getParentRoute: () => CentralRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const VendorTemplatesIndexRoute = VendorTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorTeamIndexRoute = VendorTeamIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorTeamRoute,
} as any)
const VendorSettingsIndexRoute = VendorSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorMediaIndexRoute = VendorMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorFormsIndexRoute = VendorFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorContactsIndexRoute = VendorContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorCampaignsIndexRoute = VendorCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const CentralVendorsIndexRoute = CentralVendorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CentralVendorsRoute,
} as any)
const CentralCmsPagesIndexRoute = CentralCmsPagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CentralCmsPagesRoute,
} as any)
const VendorTemplatesNewRoute = VendorTemplatesNewRouteImport.update({
  id: '/templates/new',
  path: '/templates/new',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorTemplatesNameRoute = VendorTemplatesNameRouteImport.update({
  id: '/templates/$name',
  path: '/templates/$name',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSettingsRoutingRoute = VendorSettingsRoutingRouteImport.update({
  id: '/settings/routing',
  path: '/settings/routing',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSettingsGeneralRoute = VendorSettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSettingsFeaturesRoute = VendorSettingsFeaturesRouteImport.update({
  id: '/settings/features',
  path: '/settings/features',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorSettingsAiAndTimingRoute =
  VendorSettingsAiAndTimingRouteImport.update({
    id: '/settings/ai-and-timing',
    path: '/settings/ai-and-timing',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorPagesPageIdRoute = VendorPagesPageIdRouteImport.update({
  id: '/$pageId',
  path: '/$pageId',
  getParentRoute: () => VendorPagesRoute,
} as any)
const VendorIntegrationsMetaRoute = VendorIntegrationsMetaRouteImport.update({
  id: '/integrations/meta',
  path: '/integrations/meta',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorIntegrationsGoogleRoute =
  VendorIntegrationsGoogleRouteImport.update({
    id: '/integrations/google',
    path: '/integrations/google',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorIntegrationsEcommerceRoute =
  VendorIntegrationsEcommerceRouteImport.update({
    id: '/integrations/ecommerce',
    path: '/integrations/ecommerce',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorIntegrationsConnectedAppsRoute =
  VendorIntegrationsConnectedAppsRouteImport.update({
    id: '/integrations/connected-apps',
    path: '/integrations/connected-apps',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorIntegrationsApiRoute = VendorIntegrationsApiRouteImport.update({
  id: '/integrations/api',
  path: '/integrations/api',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorInstagramSettingsRoute = VendorInstagramSettingsRouteImport.update({
  id: '/instagram/settings',
  path: '/instagram/settings',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorInstagramInboxRoute = VendorInstagramInboxRouteImport.update({
  id: '/instagram/inbox',
  path: '/instagram/inbox',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorInstagramAutomationsRoute =
  VendorInstagramAutomationsRouteImport.update({
    id: '/instagram/automations',
    path: '/instagram/automations',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorGoogleReviewsRoute = VendorGoogleReviewsRouteImport.update({
  id: '/google/reviews',
  path: '/google/reviews',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorFormsUidRoute = VendorFormsUidRouteImport.update({
  id: '/forms/$uid',
  path: '/forms/$uid',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorFacebookInboxRoute = VendorFacebookInboxRouteImport.update({
  id: '/facebook/inbox',
  path: '/facebook/inbox',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorContactsImportRoute = VendorContactsImportRouteImport.update({
  id: '/contacts/import',
  path: '/contacts/import',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorContactsCrmRoute = VendorContactsCrmRouteImport.update({
  id: '/contacts/crm',
  path: '/contacts/crm',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorContactsAutoLabelsRoute =
  VendorContactsAutoLabelsRouteImport.update({
    id: '/contacts/auto-labels',
    path: '/contacts/auto-labels',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorContactsUidRoute = VendorContactsUidRouteImport.update({
  id: '/contacts/$uid',
  path: '/contacts/$uid',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorCampaignsSuppressionRoute =
  VendorCampaignsSuppressionRouteImport.update({
    id: '/campaigns/suppression',
    path: '/campaigns/suppression',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorCampaignsNewRoute = VendorCampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => VendorRouteRoute,
} as any)
const CentralVendorsUidRoute = CentralVendorsUidRouteImport.update({
  id: '/$uid',
  path: '/$uid',
  getParentRoute: () => CentralVendorsRoute,
} as any)
const CentralCmsPagesUidRoute = CentralCmsPagesUidRouteImport.update({
  id: '/$uid',
  path: '/$uid',
  getParentRoute: () => CentralCmsPagesRoute,
} as any)
const AuthInviteTokenRoute = AuthInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => AuthRouteRoute,
} as any)
const VendorSettingsAiAgentsIndexRoute =
  VendorSettingsAiAgentsIndexRouteImport.update({
    id: '/settings/ai-agents/',
    path: '/settings/ai-agents/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorInstagramTemplatesIndexRoute =
  VendorInstagramTemplatesIndexRouteImport.update({
    id: '/instagram/templates/',
    path: '/instagram/templates/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorFacebookTemplatesIndexRoute =
  VendorFacebookTemplatesIndexRouteImport.update({
    id: '/facebook/templates/',
    path: '/facebook/templates/',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorBotsRepliesIndexRoute = VendorBotsRepliesIndexRouteImport.update({
  id: '/bots/replies/',
  path: '/bots/replies/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorBotsFlowsIndexRoute = VendorBotsFlowsIndexRouteImport.update({
  id: '/bots/flows/',
  path: '/bots/flows/',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorTemplatesNameEditRoute = VendorTemplatesNameEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => VendorTemplatesNameRoute,
} as any)
const VendorSettingsAiAgentsAgentIdRoute =
  VendorSettingsAiAgentsAgentIdRouteImport.update({
    id: '/settings/ai-agents/$agentId',
    path: '/settings/ai-agents/$agentId',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorInstagramTemplatesNewRoute =
  VendorInstagramTemplatesNewRouteImport.update({
    id: '/instagram/templates/new',
    path: '/instagram/templates/new',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorFacebookTemplatesNewRoute =
  VendorFacebookTemplatesNewRouteImport.update({
    id: '/facebook/templates/new',
    path: '/facebook/templates/new',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorCampaignsUidStatusRoute =
  VendorCampaignsUidStatusRouteImport.update({
    id: '/campaigns/$uid/status',
    path: '/campaigns/$uid/status',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorCampaignsUidEditRoute = VendorCampaignsUidEditRouteImport.update({
  id: '/campaigns/$uid/edit',
  path: '/campaigns/$uid/edit',
  getParentRoute: () => VendorRouteRoute,
} as any)
const VendorInstagramTemplatesUidEditRoute =
  VendorInstagramTemplatesUidEditRouteImport.update({
    id: '/instagram/templates/$uid/edit',
    path: '/instagram/templates/$uid/edit',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorFacebookTemplatesUidEditRoute =
  VendorFacebookTemplatesUidEditRouteImport.update({
    id: '/facebook/templates/$uid/edit',
    path: '/facebook/templates/$uid/edit',
    getParentRoute: () => VendorRouteRoute,
  } as any)
const VendorBotsFlowsFlowIdBuilderRoute =
  VendorBotsFlowsFlowIdBuilderRouteImport.update({
    id: '/bots/flows/$flowId/builder',
    path: '/bots/flows/$flowId/builder',
    getParentRoute: () => VendorRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/central': typeof CentralRouteRouteWithChildren
  '/legal': typeof LegalRouteRouteWithChildren
  '/vendor': typeof VendorRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/features': typeof FeaturesRoute
  '/pricing': typeof PricingRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/profile': typeof AuthProfileRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/central/cms-pages': typeof CentralCmsPagesRouteWithChildren
  '/central/configuration': typeof CentralConfigurationRoute
  '/central/data-deletion': typeof CentralDataDeletionRoute
  '/central/facebook-webhook-health': typeof CentralFacebookWebhookHealthRoute
  '/central/instagram-webhook-health': typeof CentralInstagramWebhookHealthRoute
  '/central/languages': typeof CentralLanguagesRoute
  '/central/manual-subscriptions': typeof CentralManualSubscriptionsRoute
  '/central/subscription-plans': typeof CentralSubscriptionPlansRoute
  '/central/subscriptions': typeof CentralSubscriptionsRoute
  '/central/translations': typeof CentralTranslationsRoute
  '/central/vendors': typeof CentralVendorsRouteWithChildren
  '/central/whatsapp-webhook-health': typeof CentralWhatsappWebhookHealthRoute
  '/deletion-status/$code': typeof DeletionStatusCodeRoute
  '/legal/data-deletion': typeof LegalDataDeletionRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/page/$slug': typeof PageSlugRoute
  '/vendor/catalog': typeof VendorCatalogRoute
  '/vendor/chat': typeof VendorChatRoute
  '/vendor/connection-test': typeof VendorConnectionTestRoute
  '/vendor/connections': typeof VendorConnectionsRoute
  '/vendor/contact-groups': typeof VendorContactGroupsRoute
  '/vendor/custom-fields': typeof VendorCustomFieldsRoute
  '/vendor/labels': typeof VendorLabelsRoute
  '/vendor/no-active-plan': typeof VendorNoActivePlanRoute
  '/vendor/orders': typeof VendorOrdersRoute
  '/vendor/pages': typeof VendorPagesRouteWithChildren
  '/vendor/payment-success': typeof VendorPaymentSuccessRoute
  '/vendor/setup': typeof VendorSetupRoute
  '/vendor/subscription': typeof VendorSubscriptionRoute
  '/vendor/team': typeof VendorTeamRouteWithChildren
  '/central/': typeof CentralIndexRoute
  '/vendor/': typeof VendorIndexRoute
  '/auth/invite/$token': typeof AuthInviteTokenRoute
  '/central/cms-pages/$uid': typeof CentralCmsPagesUidRoute
  '/central/vendors/$uid': typeof CentralVendorsUidRoute
  '/vendor/campaigns/new': typeof VendorCampaignsNewRoute
  '/vendor/campaigns/suppression': typeof VendorCampaignsSuppressionRoute
  '/vendor/contacts/$uid': typeof VendorContactsUidRoute
  '/vendor/contacts/auto-labels': typeof VendorContactsAutoLabelsRoute
  '/vendor/contacts/crm': typeof VendorContactsCrmRoute
  '/vendor/contacts/import': typeof VendorContactsImportRoute
  '/vendor/facebook/inbox': typeof VendorFacebookInboxRoute
  '/vendor/forms/$uid': typeof VendorFormsUidRoute
  '/vendor/google/reviews': typeof VendorGoogleReviewsRoute
  '/vendor/instagram/automations': typeof VendorInstagramAutomationsRoute
  '/vendor/instagram/inbox': typeof VendorInstagramInboxRoute
  '/vendor/instagram/settings': typeof VendorInstagramSettingsRoute
  '/vendor/integrations/api': typeof VendorIntegrationsApiRoute
  '/vendor/integrations/connected-apps': typeof VendorIntegrationsConnectedAppsRoute
  '/vendor/integrations/ecommerce': typeof VendorIntegrationsEcommerceRoute
  '/vendor/integrations/google': typeof VendorIntegrationsGoogleRoute
  '/vendor/integrations/meta': typeof VendorIntegrationsMetaRoute
  '/vendor/pages/$pageId': typeof VendorPagesPageIdRoute
  '/vendor/settings/ai-and-timing': typeof VendorSettingsAiAndTimingRoute
  '/vendor/settings/features': typeof VendorSettingsFeaturesRoute
  '/vendor/settings/general': typeof VendorSettingsGeneralRoute
  '/vendor/settings/routing': typeof VendorSettingsRoutingRoute
  '/vendor/templates/$name': typeof VendorTemplatesNameRouteWithChildren
  '/vendor/templates/new': typeof VendorTemplatesNewRoute
  '/central/cms-pages/': typeof CentralCmsPagesIndexRoute
  '/central/vendors/': typeof CentralVendorsIndexRoute
  '/vendor/campaigns/': typeof VendorCampaignsIndexRoute
  '/vendor/contacts/': typeof VendorContactsIndexRoute
  '/vendor/forms/': typeof VendorFormsIndexRoute
  '/vendor/media/': typeof VendorMediaIndexRoute
  '/vendor/settings/': typeof VendorSettingsIndexRoute
  '/vendor/team/': typeof VendorTeamIndexRoute
  '/vendor/templates/': typeof VendorTemplatesIndexRoute
  '/vendor/campaigns/$uid/edit': typeof VendorCampaignsUidEditRoute
  '/vendor/campaigns/$uid/status': typeof VendorCampaignsUidStatusRoute
  '/vendor/facebook/templates/new': typeof VendorFacebookTemplatesNewRoute
  '/vendor/instagram/templates/new': typeof VendorInstagramTemplatesNewRoute
  '/vendor/settings/ai-agents/$agentId': typeof VendorSettingsAiAgentsAgentIdRoute
  '/vendor/templates/$name/edit': typeof VendorTemplatesNameEditRoute
  '/vendor/bots/flows/': typeof VendorBotsFlowsIndexRoute
  '/vendor/bots/replies/': typeof VendorBotsRepliesIndexRoute
  '/vendor/facebook/templates/': typeof VendorFacebookTemplatesIndexRoute
  '/vendor/instagram/templates/': typeof VendorInstagramTemplatesIndexRoute
  '/vendor/settings/ai-agents/': typeof VendorSettingsAiAgentsIndexRoute
  '/vendor/bots/flows/$flowId/builder': typeof VendorBotsFlowsFlowIdBuilderRoute
  '/vendor/facebook/templates/$uid/edit': typeof VendorFacebookTemplatesUidEditRoute
  '/vendor/instagram/templates/$uid/edit': typeof VendorInstagramTemplatesUidEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/legal': typeof LegalRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/features': typeof FeaturesRoute
  '/pricing': typeof PricingRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/profile': typeof AuthProfileRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/central/configuration': typeof CentralConfigurationRoute
  '/central/data-deletion': typeof CentralDataDeletionRoute
  '/central/facebook-webhook-health': typeof CentralFacebookWebhookHealthRoute
  '/central/instagram-webhook-health': typeof CentralInstagramWebhookHealthRoute
  '/central/languages': typeof CentralLanguagesRoute
  '/central/manual-subscriptions': typeof CentralManualSubscriptionsRoute
  '/central/subscription-plans': typeof CentralSubscriptionPlansRoute
  '/central/subscriptions': typeof CentralSubscriptionsRoute
  '/central/translations': typeof CentralTranslationsRoute
  '/central/whatsapp-webhook-health': typeof CentralWhatsappWebhookHealthRoute
  '/deletion-status/$code': typeof DeletionStatusCodeRoute
  '/legal/data-deletion': typeof LegalDataDeletionRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/page/$slug': typeof PageSlugRoute
  '/vendor/catalog': typeof VendorCatalogRoute
  '/vendor/chat': typeof VendorChatRoute
  '/vendor/connection-test': typeof VendorConnectionTestRoute
  '/vendor/connections': typeof VendorConnectionsRoute
  '/vendor/contact-groups': typeof VendorContactGroupsRoute
  '/vendor/custom-fields': typeof VendorCustomFieldsRoute
  '/vendor/labels': typeof VendorLabelsRoute
  '/vendor/no-active-plan': typeof VendorNoActivePlanRoute
  '/vendor/orders': typeof VendorOrdersRoute
  '/vendor/pages': typeof VendorPagesRouteWithChildren
  '/vendor/payment-success': typeof VendorPaymentSuccessRoute
  '/vendor/setup': typeof VendorSetupRoute
  '/vendor/subscription': typeof VendorSubscriptionRoute
  '/central': typeof CentralIndexRoute
  '/vendor': typeof VendorIndexRoute
  '/auth/invite/$token': typeof AuthInviteTokenRoute
  '/central/cms-pages/$uid': typeof CentralCmsPagesUidRoute
  '/central/vendors/$uid': typeof CentralVendorsUidRoute
  '/vendor/campaigns/new': typeof VendorCampaignsNewRoute
  '/vendor/campaigns/suppression': typeof VendorCampaignsSuppressionRoute
  '/vendor/contacts/$uid': typeof VendorContactsUidRoute
  '/vendor/contacts/auto-labels': typeof VendorContactsAutoLabelsRoute
  '/vendor/contacts/crm': typeof VendorContactsCrmRoute
  '/vendor/contacts/import': typeof VendorContactsImportRoute
  '/vendor/facebook/inbox': typeof VendorFacebookInboxRoute
  '/vendor/forms/$uid': typeof VendorFormsUidRoute
  '/vendor/google/reviews': typeof VendorGoogleReviewsRoute
  '/vendor/instagram/automations': typeof VendorInstagramAutomationsRoute
  '/vendor/instagram/inbox': typeof VendorInstagramInboxRoute
  '/vendor/instagram/settings': typeof VendorInstagramSettingsRoute
  '/vendor/integrations/api': typeof VendorIntegrationsApiRoute
  '/vendor/integrations/connected-apps': typeof VendorIntegrationsConnectedAppsRoute
  '/vendor/integrations/ecommerce': typeof VendorIntegrationsEcommerceRoute
  '/vendor/integrations/google': typeof VendorIntegrationsGoogleRoute
  '/vendor/integrations/meta': typeof VendorIntegrationsMetaRoute
  '/vendor/pages/$pageId': typeof VendorPagesPageIdRoute
  '/vendor/settings/ai-and-timing': typeof VendorSettingsAiAndTimingRoute
  '/vendor/settings/features': typeof VendorSettingsFeaturesRoute
  '/vendor/settings/general': typeof VendorSettingsGeneralRoute
  '/vendor/settings/routing': typeof VendorSettingsRoutingRoute
  '/vendor/templates/$name': typeof VendorTemplatesNameRouteWithChildren
  '/vendor/templates/new': typeof VendorTemplatesNewRoute
  '/central/cms-pages': typeof CentralCmsPagesIndexRoute
  '/central/vendors': typeof CentralVendorsIndexRoute
  '/vendor/campaigns': typeof VendorCampaignsIndexRoute
  '/vendor/contacts': typeof VendorContactsIndexRoute
  '/vendor/forms': typeof VendorFormsIndexRoute
  '/vendor/media': typeof VendorMediaIndexRoute
  '/vendor/settings': typeof VendorSettingsIndexRoute
  '/vendor/team': typeof VendorTeamIndexRoute
  '/vendor/templates': typeof VendorTemplatesIndexRoute
  '/vendor/campaigns/$uid/edit': typeof VendorCampaignsUidEditRoute
  '/vendor/campaigns/$uid/status': typeof VendorCampaignsUidStatusRoute
  '/vendor/facebook/templates/new': typeof VendorFacebookTemplatesNewRoute
  '/vendor/instagram/templates/new': typeof VendorInstagramTemplatesNewRoute
  '/vendor/settings/ai-agents/$agentId': typeof VendorSettingsAiAgentsAgentIdRoute
  '/vendor/templates/$name/edit': typeof VendorTemplatesNameEditRoute
  '/vendor/bots/flows': typeof VendorBotsFlowsIndexRoute
  '/vendor/bots/replies': typeof VendorBotsRepliesIndexRoute
  '/vendor/facebook/templates': typeof VendorFacebookTemplatesIndexRoute
  '/vendor/instagram/templates': typeof VendorInstagramTemplatesIndexRoute
  '/vendor/settings/ai-agents': typeof VendorSettingsAiAgentsIndexRoute
  '/vendor/bots/flows/$flowId/builder': typeof VendorBotsFlowsFlowIdBuilderRoute
  '/vendor/facebook/templates/$uid/edit': typeof VendorFacebookTemplatesUidEditRoute
  '/vendor/instagram/templates/$uid/edit': typeof VendorInstagramTemplatesUidEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/central': typeof CentralRouteRouteWithChildren
  '/legal': typeof LegalRouteRouteWithChildren
  '/vendor': typeof VendorRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/features': typeof FeaturesRoute
  '/pricing': typeof PricingRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/profile': typeof AuthProfileRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/central/cms-pages': typeof CentralCmsPagesRouteWithChildren
  '/central/configuration': typeof CentralConfigurationRoute
  '/central/data-deletion': typeof CentralDataDeletionRoute
  '/central/facebook-webhook-health': typeof CentralFacebookWebhookHealthRoute
  '/central/instagram-webhook-health': typeof CentralInstagramWebhookHealthRoute
  '/central/languages': typeof CentralLanguagesRoute
  '/central/manual-subscriptions': typeof CentralManualSubscriptionsRoute
  '/central/subscription-plans': typeof CentralSubscriptionPlansRoute
  '/central/subscriptions': typeof CentralSubscriptionsRoute
  '/central/translations': typeof CentralTranslationsRoute
  '/central/vendors': typeof CentralVendorsRouteWithChildren
  '/central/whatsapp-webhook-health': typeof CentralWhatsappWebhookHealthRoute
  '/deletion-status/$code': typeof DeletionStatusCodeRoute
  '/legal/data-deletion': typeof LegalDataDeletionRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/page/$slug': typeof PageSlugRoute
  '/vendor/catalog': typeof VendorCatalogRoute
  '/vendor/chat': typeof VendorChatRoute
  '/vendor/connection-test': typeof VendorConnectionTestRoute
  '/vendor/connections': typeof VendorConnectionsRoute
  '/vendor/contact-groups': typeof VendorContactGroupsRoute
  '/vendor/custom-fields': typeof VendorCustomFieldsRoute
  '/vendor/labels': typeof VendorLabelsRoute
  '/vendor/no-active-plan': typeof VendorNoActivePlanRoute
  '/vendor/orders': typeof VendorOrdersRoute
  '/vendor/pages': typeof VendorPagesRouteWithChildren
  '/vendor/payment-success': typeof VendorPaymentSuccessRoute
  '/vendor/setup': typeof VendorSetupRoute
  '/vendor/subscription': typeof VendorSubscriptionRoute
  '/vendor/team': typeof VendorTeamRouteWithChildren
  '/central/': typeof CentralIndexRoute
  '/vendor/': typeof VendorIndexRoute
  '/auth/invite/$token': typeof AuthInviteTokenRoute
  '/central/cms-pages/$uid': typeof CentralCmsPagesUidRoute
  '/central/vendors/$uid': typeof CentralVendorsUidRoute
  '/vendor/campaigns/new': typeof VendorCampaignsNewRoute
  '/vendor/campaigns/suppression': typeof VendorCampaignsSuppressionRoute
  '/vendor/contacts/$uid': typeof VendorContactsUidRoute
  '/vendor/contacts/auto-labels': typeof VendorContactsAutoLabelsRoute
  '/vendor/contacts/crm': typeof VendorContactsCrmRoute
  '/vendor/contacts/import': typeof VendorContactsImportRoute
  '/vendor/facebook/inbox': typeof VendorFacebookInboxRoute
  '/vendor/forms/$uid': typeof VendorFormsUidRoute
  '/vendor/google/reviews': typeof VendorGoogleReviewsRoute
  '/vendor/instagram/automations': typeof VendorInstagramAutomationsRoute
  '/vendor/instagram/inbox': typeof VendorInstagramInboxRoute
  '/vendor/instagram/settings': typeof VendorInstagramSettingsRoute
  '/vendor/integrations/api': typeof VendorIntegrationsApiRoute
  '/vendor/integrations/connected-apps': typeof VendorIntegrationsConnectedAppsRoute
  '/vendor/integrations/ecommerce': typeof VendorIntegrationsEcommerceRoute
  '/vendor/integrations/google': typeof VendorIntegrationsGoogleRoute
  '/vendor/integrations/meta': typeof VendorIntegrationsMetaRoute
  '/vendor/pages/$pageId': typeof VendorPagesPageIdRoute
  '/vendor/settings/ai-and-timing': typeof VendorSettingsAiAndTimingRoute
  '/vendor/settings/features': typeof VendorSettingsFeaturesRoute
  '/vendor/settings/general': typeof VendorSettingsGeneralRoute
  '/vendor/settings/routing': typeof VendorSettingsRoutingRoute
  '/vendor/templates/$name': typeof VendorTemplatesNameRouteWithChildren
  '/vendor/templates/new': typeof VendorTemplatesNewRoute
  '/central/cms-pages/': typeof CentralCmsPagesIndexRoute
  '/central/vendors/': typeof CentralVendorsIndexRoute
  '/vendor/campaigns/': typeof VendorCampaignsIndexRoute
  '/vendor/contacts/': typeof VendorContactsIndexRoute
  '/vendor/forms/': typeof VendorFormsIndexRoute
  '/vendor/media/': typeof VendorMediaIndexRoute
  '/vendor/settings/': typeof VendorSettingsIndexRoute
  '/vendor/team/': typeof VendorTeamIndexRoute
  '/vendor/templates/': typeof VendorTemplatesIndexRoute
  '/vendor/campaigns/$uid/edit': typeof VendorCampaignsUidEditRoute
  '/vendor/campaigns/$uid/status': typeof VendorCampaignsUidStatusRoute
  '/vendor/facebook/templates/new': typeof VendorFacebookTemplatesNewRoute
  '/vendor/instagram/templates/new': typeof VendorInstagramTemplatesNewRoute
  '/vendor/settings/ai-agents/$agentId': typeof VendorSettingsAiAgentsAgentIdRoute
  '/vendor/templates/$name/edit': typeof VendorTemplatesNameEditRoute
  '/vendor/bots/flows/': typeof VendorBotsFlowsIndexRoute
  '/vendor/bots/replies/': typeof VendorBotsRepliesIndexRoute
  '/vendor/facebook/templates/': typeof VendorFacebookTemplatesIndexRoute
  '/vendor/instagram/templates/': typeof VendorInstagramTemplatesIndexRoute
  '/vendor/settings/ai-agents/': typeof VendorSettingsAiAgentsIndexRoute
  '/vendor/bots/flows/$flowId/builder': typeof VendorBotsFlowsFlowIdBuilderRoute
  '/vendor/facebook/templates/$uid/edit': typeof VendorFacebookTemplatesUidEditRoute
  '/vendor/instagram/templates/$uid/edit': typeof VendorInstagramTemplatesUidEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/central'
    | '/legal'
    | '/vendor'
    | '/about'
    | '/contact'
    | '/features'
    | '/pricing'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/profile'
    | '/auth/register'
    | '/auth/reset-password'
    | '/central/cms-pages'
    | '/central/configuration'
    | '/central/data-deletion'
    | '/central/facebook-webhook-health'
    | '/central/instagram-webhook-health'
    | '/central/languages'
    | '/central/manual-subscriptions'
    | '/central/subscription-plans'
    | '/central/subscriptions'
    | '/central/translations'
    | '/central/vendors'
    | '/central/whatsapp-webhook-health'
    | '/deletion-status/$code'
    | '/legal/data-deletion'
    | '/legal/privacy'
    | '/legal/terms'
    | '/page/$slug'
    | '/vendor/catalog'
    | '/vendor/chat'
    | '/vendor/connection-test'
    | '/vendor/connections'
    | '/vendor/contact-groups'
    | '/vendor/custom-fields'
    | '/vendor/labels'
    | '/vendor/no-active-plan'
    | '/vendor/orders'
    | '/vendor/pages'
    | '/vendor/payment-success'
    | '/vendor/setup'
    | '/vendor/subscription'
    | '/vendor/team'
    | '/central/'
    | '/vendor/'
    | '/auth/invite/$token'
    | '/central/cms-pages/$uid'
    | '/central/vendors/$uid'
    | '/vendor/campaigns/new'
    | '/vendor/campaigns/suppression'
    | '/vendor/contacts/$uid'
    | '/vendor/contacts/auto-labels'
    | '/vendor/contacts/crm'
    | '/vendor/contacts/import'
    | '/vendor/facebook/inbox'
    | '/vendor/forms/$uid'
    | '/vendor/google/reviews'
    | '/vendor/instagram/automations'
    | '/vendor/instagram/inbox'
    | '/vendor/instagram/settings'
    | '/vendor/integrations/api'
    | '/vendor/integrations/connected-apps'
    | '/vendor/integrations/ecommerce'
    | '/vendor/integrations/google'
    | '/vendor/integrations/meta'
    | '/vendor/pages/$pageId'
    | '/vendor/settings/ai-and-timing'
    | '/vendor/settings/features'
    | '/vendor/settings/general'
    | '/vendor/settings/routing'
    | '/vendor/templates/$name'
    | '/vendor/templates/new'
    | '/central/cms-pages/'
    | '/central/vendors/'
    | '/vendor/campaigns/'
    | '/vendor/contacts/'
    | '/vendor/forms/'
    | '/vendor/media/'
    | '/vendor/settings/'
    | '/vendor/team/'
    | '/vendor/templates/'
    | '/vendor/campaigns/$uid/edit'
    | '/vendor/campaigns/$uid/status'
    | '/vendor/facebook/templates/new'
    | '/vendor/instagram/templates/new'
    | '/vendor/settings/ai-agents/$agentId'
    | '/vendor/templates/$name/edit'
    | '/vendor/bots/flows/'
    | '/vendor/bots/replies/'
    | '/vendor/facebook/templates/'
    | '/vendor/instagram/templates/'
    | '/vendor/settings/ai-agents/'
    | '/vendor/bots/flows/$flowId/builder'
    | '/vendor/facebook/templates/$uid/edit'
    | '/vendor/instagram/templates/$uid/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/legal'
    | '/about'
    | '/contact'
    | '/features'
    | '/pricing'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/profile'
    | '/auth/register'
    | '/auth/reset-password'
    | '/central/configuration'
    | '/central/data-deletion'
    | '/central/facebook-webhook-health'
    | '/central/instagram-webhook-health'
    | '/central/languages'
    | '/central/manual-subscriptions'
    | '/central/subscription-plans'
    | '/central/subscriptions'
    | '/central/translations'
    | '/central/whatsapp-webhook-health'
    | '/deletion-status/$code'
    | '/legal/data-deletion'
    | '/legal/privacy'
    | '/legal/terms'
    | '/page/$slug'
    | '/vendor/catalog'
    | '/vendor/chat'
    | '/vendor/connection-test'
    | '/vendor/connections'
    | '/vendor/contact-groups'
    | '/vendor/custom-fields'
    | '/vendor/labels'
    | '/vendor/no-active-plan'
    | '/vendor/orders'
    | '/vendor/pages'
    | '/vendor/payment-success'
    | '/vendor/setup'
    | '/vendor/subscription'
    | '/central'
    | '/vendor'
    | '/auth/invite/$token'
    | '/central/cms-pages/$uid'
    | '/central/vendors/$uid'
    | '/vendor/campaigns/new'
    | '/vendor/campaigns/suppression'
    | '/vendor/contacts/$uid'
    | '/vendor/contacts/auto-labels'
    | '/vendor/contacts/crm'
    | '/vendor/contacts/import'
    | '/vendor/facebook/inbox'
    | '/vendor/forms/$uid'
    | '/vendor/google/reviews'
    | '/vendor/instagram/automations'
    | '/vendor/instagram/inbox'
    | '/vendor/instagram/settings'
    | '/vendor/integrations/api'
    | '/vendor/integrations/connected-apps'
    | '/vendor/integrations/ecommerce'
    | '/vendor/integrations/google'
    | '/vendor/integrations/meta'
    | '/vendor/pages/$pageId'
    | '/vendor/settings/ai-and-timing'
    | '/vendor/settings/features'
    | '/vendor/settings/general'
    | '/vendor/settings/routing'
    | '/vendor/templates/$name'
    | '/vendor/templates/new'
    | '/central/cms-pages'
    | '/central/vendors'
    | '/vendor/campaigns'
    | '/vendor/contacts'
    | '/vendor/forms'
    | '/vendor/media'
    | '/vendor/settings'
    | '/vendor/team'
    | '/vendor/templates'
    | '/vendor/campaigns/$uid/edit'
    | '/vendor/campaigns/$uid/status'
    | '/vendor/facebook/templates/new'
    | '/vendor/instagram/templates/new'
    | '/vendor/settings/ai-agents/$agentId'
    | '/vendor/templates/$name/edit'
    | '/vendor/bots/flows'
    | '/vendor/bots/replies'
    | '/vendor/facebook/templates'
    | '/vendor/instagram/templates'
    | '/vendor/settings/ai-agents'
    | '/vendor/bots/flows/$flowId/builder'
    | '/vendor/facebook/templates/$uid/edit'
    | '/vendor/instagram/templates/$uid/edit'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/central'
    | '/legal'
    | '/vendor'
    | '/about'
    | '/contact'
    | '/features'
    | '/pricing'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/profile'
    | '/auth/register'
    | '/auth/reset-password'
    | '/central/cms-pages'
    | '/central/configuration'
    | '/central/data-deletion'
    | '/central/facebook-webhook-health'
    | '/central/instagram-webhook-health'
    | '/central/languages'
    | '/central/manual-subscriptions'
    | '/central/subscription-plans'
    | '/central/subscriptions'
    | '/central/translations'
    | '/central/vendors'
    | '/central/whatsapp-webhook-health'
    | '/deletion-status/$code'
    | '/legal/data-deletion'
    | '/legal/privacy'
    | '/legal/terms'
    | '/page/$slug'
    | '/vendor/catalog'
    | '/vendor/chat'
    | '/vendor/connection-test'
    | '/vendor/connections'
    | '/vendor/contact-groups'
    | '/vendor/custom-fields'
    | '/vendor/labels'
    | '/vendor/no-active-plan'
    | '/vendor/orders'
    | '/vendor/pages'
    | '/vendor/payment-success'
    | '/vendor/setup'
    | '/vendor/subscription'
    | '/vendor/team'
    | '/central/'
    | '/vendor/'
    | '/auth/invite/$token'
    | '/central/cms-pages/$uid'
    | '/central/vendors/$uid'
    | '/vendor/campaigns/new'
    | '/vendor/campaigns/suppression'
    | '/vendor/contacts/$uid'
    | '/vendor/contacts/auto-labels'
    | '/vendor/contacts/crm'
    | '/vendor/contacts/import'
    | '/vendor/facebook/inbox'
    | '/vendor/forms/$uid'
    | '/vendor/google/reviews'
    | '/vendor/instagram/automations'
    | '/vendor/instagram/inbox'
    | '/vendor/instagram/settings'
    | '/vendor/integrations/api'
    | '/vendor/integrations/connected-apps'
    | '/vendor/integrations/ecommerce'
    | '/vendor/integrations/google'
    | '/vendor/integrations/meta'
    | '/vendor/pages/$pageId'
    | '/vendor/settings/ai-and-timing'
    | '/vendor/settings/features'
    | '/vendor/settings/general'
    | '/vendor/settings/routing'
    | '/vendor/templates/$name'
    | '/vendor/templates/new'
    | '/central/cms-pages/'
    | '/central/vendors/'
    | '/vendor/campaigns/'
    | '/vendor/contacts/'
    | '/vendor/forms/'
    | '/vendor/media/'
    | '/vendor/settings/'
    | '/vendor/team/'
    | '/vendor/templates/'
    | '/vendor/campaigns/$uid/edit'
    | '/vendor/campaigns/$uid/status'
    | '/vendor/facebook/templates/new'
    | '/vendor/instagram/templates/new'
    | '/vendor/settings/ai-agents/$agentId'
    | '/vendor/templates/$name/edit'
    | '/vendor/bots/flows/'
    | '/vendor/bots/replies/'
    | '/vendor/facebook/templates/'
    | '/vendor/instagram/templates/'
    | '/vendor/settings/ai-agents/'
    | '/vendor/bots/flows/$flowId/builder'
    | '/vendor/facebook/templates/$uid/edit'
    | '/vendor/instagram/templates/$uid/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  CentralRouteRoute: typeof CentralRouteRouteWithChildren
  LegalRouteRoute: typeof LegalRouteRouteWithChildren
  VendorRouteRoute: typeof VendorRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  FeaturesRoute: typeof FeaturesRoute
  PricingRoute: typeof PricingRoute
  DeletionStatusCodeRoute: typeof DeletionStatusCodeRoute
  PageSlugRoute: typeof PageSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/central': {
      id: '/central'
      path: '/central'
      fullPath: '/central'
      preLoaderRoute: typeof CentralRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/': {
      id: '/vendor/'
      path: '/'
      fullPath: '/vendor/'
      preLoaderRoute: typeof VendorIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/central/': {
      id: '/central/'
      path: '/'
      fullPath: '/central/'
      preLoaderRoute: typeof CentralIndexRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/vendor/team': {
      id: '/vendor/team'
      path: '/team'
      fullPath: '/vendor/team'
      preLoaderRoute: typeof VendorTeamRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/subscription': {
      id: '/vendor/subscription'
      path: '/subscription'
      fullPath: '/vendor/subscription'
      preLoaderRoute: typeof VendorSubscriptionRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/setup': {
      id: '/vendor/setup'
      path: '/setup'
      fullPath: '/vendor/setup'
      preLoaderRoute: typeof VendorSetupRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/payment-success': {
      id: '/vendor/payment-success'
      path: '/payment-success'
      fullPath: '/vendor/payment-success'
      preLoaderRoute: typeof VendorPaymentSuccessRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/pages': {
      id: '/vendor/pages'
      path: '/pages'
      fullPath: '/vendor/pages'
      preLoaderRoute: typeof VendorPagesRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/orders': {
      id: '/vendor/orders'
      path: '/orders'
      fullPath: '/vendor/orders'
      preLoaderRoute: typeof VendorOrdersRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/no-active-plan': {
      id: '/vendor/no-active-plan'
      path: '/no-active-plan'
      fullPath: '/vendor/no-active-plan'
      preLoaderRoute: typeof VendorNoActivePlanRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/labels': {
      id: '/vendor/labels'
      path: '/labels'
      fullPath: '/vendor/labels'
      preLoaderRoute: typeof VendorLabelsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/custom-fields': {
      id: '/vendor/custom-fields'
      path: '/custom-fields'
      fullPath: '/vendor/custom-fields'
      preLoaderRoute: typeof VendorCustomFieldsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/contact-groups': {
      id: '/vendor/contact-groups'
      path: '/contact-groups'
      fullPath: '/vendor/contact-groups'
      preLoaderRoute: typeof VendorContactGroupsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/connections': {
      id: '/vendor/connections'
      path: '/connections'
      fullPath: '/vendor/connections'
      preLoaderRoute: typeof VendorConnectionsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/connection-test': {
      id: '/vendor/connection-test'
      path: '/connection-test'
      fullPath: '/vendor/connection-test'
      preLoaderRoute: typeof VendorConnectionTestRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/chat': {
      id: '/vendor/chat'
      path: '/chat'
      fullPath: '/vendor/chat'
      preLoaderRoute: typeof VendorChatRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/catalog': {
      id: '/vendor/catalog'
      path: '/catalog'
      fullPath: '/vendor/catalog'
      preLoaderRoute: typeof VendorCatalogRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/page/$slug': {
      id: '/page/$slug'
      path: '/page/$slug'
      fullPath: '/page/$slug'
      preLoaderRoute: typeof PageSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/legal/data-deletion': {
      id: '/legal/data-deletion'
      path: '/data-deletion'
      fullPath: '/legal/data-deletion'
      preLoaderRoute: typeof LegalDataDeletionRouteImport
      parentRoute: typeof LegalRouteRoute
    }
    '/deletion-status/$code': {
      id: '/deletion-status/$code'
      path: '/deletion-status/$code'
      fullPath: '/deletion-status/$code'
      preLoaderRoute: typeof DeletionStatusCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/central/whatsapp-webhook-health': {
      id: '/central/whatsapp-webhook-health'
      path: '/whatsapp-webhook-health'
      fullPath: '/central/whatsapp-webhook-health'
      preLoaderRoute: typeof CentralWhatsappWebhookHealthRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/vendors': {
      id: '/central/vendors'
      path: '/vendors'
      fullPath: '/central/vendors'
      preLoaderRoute: typeof CentralVendorsRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/translations': {
      id: '/central/translations'
      path: '/translations'
      fullPath: '/central/translations'
      preLoaderRoute: typeof CentralTranslationsRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/subscriptions': {
      id: '/central/subscriptions'
      path: '/subscriptions'
      fullPath: '/central/subscriptions'
      preLoaderRoute: typeof CentralSubscriptionsRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/subscription-plans': {
      id: '/central/subscription-plans'
      path: '/subscription-plans'
      fullPath: '/central/subscription-plans'
      preLoaderRoute: typeof CentralSubscriptionPlansRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/manual-subscriptions': {
      id: '/central/manual-subscriptions'
      path: '/manual-subscriptions'
      fullPath: '/central/manual-subscriptions'
      preLoaderRoute: typeof CentralManualSubscriptionsRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/languages': {
      id: '/central/languages'
      path: '/languages'
      fullPath: '/central/languages'
      preLoaderRoute: typeof CentralLanguagesRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/instagram-webhook-health': {
      id: '/central/instagram-webhook-health'
      path: '/instagram-webhook-health'
      fullPath: '/central/instagram-webhook-health'
      preLoaderRoute: typeof CentralInstagramWebhookHealthRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/facebook-webhook-health': {
      id: '/central/facebook-webhook-health'
      path: '/facebook-webhook-health'
      fullPath: '/central/facebook-webhook-health'
      preLoaderRoute: typeof CentralFacebookWebhookHealthRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/data-deletion': {
      id: '/central/data-deletion'
      path: '/data-deletion'
      fullPath: '/central/data-deletion'
      preLoaderRoute: typeof CentralDataDeletionRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/configuration': {
      id: '/central/configuration'
      path: '/configuration'
      fullPath: '/central/configuration'
      preLoaderRoute: typeof CentralConfigurationRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/central/cms-pages': {
      id: '/central/cms-pages'
      path: '/cms-pages'
      fullPath: '/central/cms-pages'
      preLoaderRoute: typeof CentralCmsPagesRouteImport
      parentRoute: typeof CentralRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/profile': {
      id: '/auth/profile'
      path: '/profile'
      fullPath: '/auth/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/vendor/templates/': {
      id: '/vendor/templates/'
      path: '/templates'
      fullPath: '/vendor/templates/'
      preLoaderRoute: typeof VendorTemplatesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/team/': {
      id: '/vendor/team/'
      path: '/'
      fullPath: '/vendor/team/'
      preLoaderRoute: typeof VendorTeamIndexRouteImport
      parentRoute: typeof VendorTeamRoute
    }
    '/vendor/settings/': {
      id: '/vendor/settings/'
      path: '/settings'
      fullPath: '/vendor/settings/'
      preLoaderRoute: typeof VendorSettingsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/media/': {
      id: '/vendor/media/'
      path: '/media'
      fullPath: '/vendor/media/'
      preLoaderRoute: typeof VendorMediaIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/forms/': {
      id: '/vendor/forms/'
      path: '/forms'
      fullPath: '/vendor/forms/'
      preLoaderRoute: typeof VendorFormsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/contacts/': {
      id: '/vendor/contacts/'
      path: '/contacts'
      fullPath: '/vendor/contacts/'
      preLoaderRoute: typeof VendorContactsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/campaigns/': {
      id: '/vendor/campaigns/'
      path: '/campaigns'
      fullPath: '/vendor/campaigns/'
      preLoaderRoute: typeof VendorCampaignsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/central/vendors/': {
      id: '/central/vendors/'
      path: '/'
      fullPath: '/central/vendors/'
      preLoaderRoute: typeof CentralVendorsIndexRouteImport
      parentRoute: typeof CentralVendorsRoute
    }
    '/central/cms-pages/': {
      id: '/central/cms-pages/'
      path: '/'
      fullPath: '/central/cms-pages/'
      preLoaderRoute: typeof CentralCmsPagesIndexRouteImport
      parentRoute: typeof CentralCmsPagesRoute
    }
    '/vendor/templates/new': {
      id: '/vendor/templates/new'
      path: '/templates/new'
      fullPath: '/vendor/templates/new'
      preLoaderRoute: typeof VendorTemplatesNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/templates/$name': {
      id: '/vendor/templates/$name'
      path: '/templates/$name'
      fullPath: '/vendor/templates/$name'
      preLoaderRoute: typeof VendorTemplatesNameRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/settings/routing': {
      id: '/vendor/settings/routing'
      path: '/settings/routing'
      fullPath: '/vendor/settings/routing'
      preLoaderRoute: typeof VendorSettingsRoutingRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/settings/general': {
      id: '/vendor/settings/general'
      path: '/settings/general'
      fullPath: '/vendor/settings/general'
      preLoaderRoute: typeof VendorSettingsGeneralRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/settings/features': {
      id: '/vendor/settings/features'
      path: '/settings/features'
      fullPath: '/vendor/settings/features'
      preLoaderRoute: typeof VendorSettingsFeaturesRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/settings/ai-and-timing': {
      id: '/vendor/settings/ai-and-timing'
      path: '/settings/ai-and-timing'
      fullPath: '/vendor/settings/ai-and-timing'
      preLoaderRoute: typeof VendorSettingsAiAndTimingRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/pages/$pageId': {
      id: '/vendor/pages/$pageId'
      path: '/$pageId'
      fullPath: '/vendor/pages/$pageId'
      preLoaderRoute: typeof VendorPagesPageIdRouteImport
      parentRoute: typeof VendorPagesRoute
    }
    '/vendor/integrations/meta': {
      id: '/vendor/integrations/meta'
      path: '/integrations/meta'
      fullPath: '/vendor/integrations/meta'
      preLoaderRoute: typeof VendorIntegrationsMetaRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/integrations/google': {
      id: '/vendor/integrations/google'
      path: '/integrations/google'
      fullPath: '/vendor/integrations/google'
      preLoaderRoute: typeof VendorIntegrationsGoogleRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/integrations/ecommerce': {
      id: '/vendor/integrations/ecommerce'
      path: '/integrations/ecommerce'
      fullPath: '/vendor/integrations/ecommerce'
      preLoaderRoute: typeof VendorIntegrationsEcommerceRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/integrations/connected-apps': {
      id: '/vendor/integrations/connected-apps'
      path: '/integrations/connected-apps'
      fullPath: '/vendor/integrations/connected-apps'
      preLoaderRoute: typeof VendorIntegrationsConnectedAppsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/integrations/api': {
      id: '/vendor/integrations/api'
      path: '/integrations/api'
      fullPath: '/vendor/integrations/api'
      preLoaderRoute: typeof VendorIntegrationsApiRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/instagram/settings': {
      id: '/vendor/instagram/settings'
      path: '/instagram/settings'
      fullPath: '/vendor/instagram/settings'
      preLoaderRoute: typeof VendorInstagramSettingsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/instagram/inbox': {
      id: '/vendor/instagram/inbox'
      path: '/instagram/inbox'
      fullPath: '/vendor/instagram/inbox'
      preLoaderRoute: typeof VendorInstagramInboxRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/instagram/automations': {
      id: '/vendor/instagram/automations'
      path: '/instagram/automations'
      fullPath: '/vendor/instagram/automations'
      preLoaderRoute: typeof VendorInstagramAutomationsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/google/reviews': {
      id: '/vendor/google/reviews'
      path: '/google/reviews'
      fullPath: '/vendor/google/reviews'
      preLoaderRoute: typeof VendorGoogleReviewsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/forms/$uid': {
      id: '/vendor/forms/$uid'
      path: '/forms/$uid'
      fullPath: '/vendor/forms/$uid'
      preLoaderRoute: typeof VendorFormsUidRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/facebook/inbox': {
      id: '/vendor/facebook/inbox'
      path: '/facebook/inbox'
      fullPath: '/vendor/facebook/inbox'
      preLoaderRoute: typeof VendorFacebookInboxRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/contacts/import': {
      id: '/vendor/contacts/import'
      path: '/contacts/import'
      fullPath: '/vendor/contacts/import'
      preLoaderRoute: typeof VendorContactsImportRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/contacts/crm': {
      id: '/vendor/contacts/crm'
      path: '/contacts/crm'
      fullPath: '/vendor/contacts/crm'
      preLoaderRoute: typeof VendorContactsCrmRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/contacts/auto-labels': {
      id: '/vendor/contacts/auto-labels'
      path: '/contacts/auto-labels'
      fullPath: '/vendor/contacts/auto-labels'
      preLoaderRoute: typeof VendorContactsAutoLabelsRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/contacts/$uid': {
      id: '/vendor/contacts/$uid'
      path: '/contacts/$uid'
      fullPath: '/vendor/contacts/$uid'
      preLoaderRoute: typeof VendorContactsUidRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/campaigns/suppression': {
      id: '/vendor/campaigns/suppression'
      path: '/campaigns/suppression'
      fullPath: '/vendor/campaigns/suppression'
      preLoaderRoute: typeof VendorCampaignsSuppressionRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/campaigns/new': {
      id: '/vendor/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/vendor/campaigns/new'
      preLoaderRoute: typeof VendorCampaignsNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/central/vendors/$uid': {
      id: '/central/vendors/$uid'
      path: '/$uid'
      fullPath: '/central/vendors/$uid'
      preLoaderRoute: typeof CentralVendorsUidRouteImport
      parentRoute: typeof CentralVendorsRoute
    }
    '/central/cms-pages/$uid': {
      id: '/central/cms-pages/$uid'
      path: '/$uid'
      fullPath: '/central/cms-pages/$uid'
      preLoaderRoute: typeof CentralCmsPagesUidRouteImport
      parentRoute: typeof CentralCmsPagesRoute
    }
    '/auth/invite/$token': {
      id: '/auth/invite/$token'
      path: '/invite/$token'
      fullPath: '/auth/invite/$token'
      preLoaderRoute: typeof AuthInviteTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/vendor/settings/ai-agents/': {
      id: '/vendor/settings/ai-agents/'
      path: '/settings/ai-agents'
      fullPath: '/vendor/settings/ai-agents/'
      preLoaderRoute: typeof VendorSettingsAiAgentsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/instagram/templates/': {
      id: '/vendor/instagram/templates/'
      path: '/instagram/templates'
      fullPath: '/vendor/instagram/templates/'
      preLoaderRoute: typeof VendorInstagramTemplatesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/facebook/templates/': {
      id: '/vendor/facebook/templates/'
      path: '/facebook/templates'
      fullPath: '/vendor/facebook/templates/'
      preLoaderRoute: typeof VendorFacebookTemplatesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/bots/replies/': {
      id: '/vendor/bots/replies/'
      path: '/bots/replies'
      fullPath: '/vendor/bots/replies/'
      preLoaderRoute: typeof VendorBotsRepliesIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/bots/flows/': {
      id: '/vendor/bots/flows/'
      path: '/bots/flows'
      fullPath: '/vendor/bots/flows/'
      preLoaderRoute: typeof VendorBotsFlowsIndexRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/templates/$name/edit': {
      id: '/vendor/templates/$name/edit'
      path: '/edit'
      fullPath: '/vendor/templates/$name/edit'
      preLoaderRoute: typeof VendorTemplatesNameEditRouteImport
      parentRoute: typeof VendorTemplatesNameRoute
    }
    '/vendor/settings/ai-agents/$agentId': {
      id: '/vendor/settings/ai-agents/$agentId'
      path: '/settings/ai-agents/$agentId'
      fullPath: '/vendor/settings/ai-agents/$agentId'
      preLoaderRoute: typeof VendorSettingsAiAgentsAgentIdRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/instagram/templates/new': {
      id: '/vendor/instagram/templates/new'
      path: '/instagram/templates/new'
      fullPath: '/vendor/instagram/templates/new'
      preLoaderRoute: typeof VendorInstagramTemplatesNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/facebook/templates/new': {
      id: '/vendor/facebook/templates/new'
      path: '/facebook/templates/new'
      fullPath: '/vendor/facebook/templates/new'
      preLoaderRoute: typeof VendorFacebookTemplatesNewRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/campaigns/$uid/status': {
      id: '/vendor/campaigns/$uid/status'
      path: '/campaigns/$uid/status'
      fullPath: '/vendor/campaigns/$uid/status'
      preLoaderRoute: typeof VendorCampaignsUidStatusRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/campaigns/$uid/edit': {
      id: '/vendor/campaigns/$uid/edit'
      path: '/campaigns/$uid/edit'
      fullPath: '/vendor/campaigns/$uid/edit'
      preLoaderRoute: typeof VendorCampaignsUidEditRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/instagram/templates/$uid/edit': {
      id: '/vendor/instagram/templates/$uid/edit'
      path: '/instagram/templates/$uid/edit'
      fullPath: '/vendor/instagram/templates/$uid/edit'
      preLoaderRoute: typeof VendorInstagramTemplatesUidEditRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/facebook/templates/$uid/edit': {
      id: '/vendor/facebook/templates/$uid/edit'
      path: '/facebook/templates/$uid/edit'
      fullPath: '/vendor/facebook/templates/$uid/edit'
      preLoaderRoute: typeof VendorFacebookTemplatesUidEditRouteImport
      parentRoute: typeof VendorRouteRoute
    }
    '/vendor/bots/flows/$flowId/builder': {
      id: '/vendor/bots/flows/$flowId/builder'
      path: '/bots/flows/$flowId/builder'
      fullPath: '/vendor/bots/flows/$flowId/builder'
      preLoaderRoute: typeof VendorBotsFlowsFlowIdBuilderRouteImport
      parentRoute: typeof VendorRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthProfileRoute: typeof AuthProfileRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthInviteTokenRoute: typeof AuthInviteTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthProfileRoute: AuthProfileRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthInviteTokenRoute: AuthInviteTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface CentralCmsPagesRouteChildren {
  CentralCmsPagesUidRoute: typeof CentralCmsPagesUidRoute
  CentralCmsPagesIndexRoute: typeof CentralCmsPagesIndexRoute
}

const CentralCmsPagesRouteChildren: CentralCmsPagesRouteChildren = {
  CentralCmsPagesUidRoute: CentralCmsPagesUidRoute,
  CentralCmsPagesIndexRoute: CentralCmsPagesIndexRoute,
}

const CentralCmsPagesRouteWithChildren = CentralCmsPagesRoute._addFileChildren(
  CentralCmsPagesRouteChildren,
)

interface CentralVendorsRouteChildren {
  CentralVendorsUidRoute: typeof CentralVendorsUidRoute
  CentralVendorsIndexRoute: typeof CentralVendorsIndexRoute
}

const CentralVendorsRouteChildren: CentralVendorsRouteChildren = {
  CentralVendorsUidRoute: CentralVendorsUidRoute,
  CentralVendorsIndexRoute: CentralVendorsIndexRoute,
}

const CentralVendorsRouteWithChildren = CentralVendorsRoute._addFileChildren(
  CentralVendorsRouteChildren,
)

interface CentralRouteRouteChildren {
  CentralCmsPagesRoute: typeof CentralCmsPagesRouteWithChildren
  CentralConfigurationRoute: typeof CentralConfigurationRoute
  CentralDataDeletionRoute: typeof CentralDataDeletionRoute
  CentralFacebookWebhookHealthRoute: typeof CentralFacebookWebhookHealthRoute
  CentralInstagramWebhookHealthRoute: typeof CentralInstagramWebhookHealthRoute
  CentralLanguagesRoute: typeof CentralLanguagesRoute
  CentralManualSubscriptionsRoute: typeof CentralManualSubscriptionsRoute
  CentralSubscriptionPlansRoute: typeof CentralSubscriptionPlansRoute
  CentralSubscriptionsRoute: typeof CentralSubscriptionsRoute
  CentralTranslationsRoute: typeof CentralTranslationsRoute
  CentralVendorsRoute: typeof CentralVendorsRouteWithChildren
  CentralWhatsappWebhookHealthRoute: typeof CentralWhatsappWebhookHealthRoute
  CentralIndexRoute: typeof CentralIndexRoute
}

const CentralRouteRouteChildren: CentralRouteRouteChildren = {
  CentralCmsPagesRoute: CentralCmsPagesRouteWithChildren,
  CentralConfigurationRoute: CentralConfigurationRoute,
  CentralDataDeletionRoute: CentralDataDeletionRoute,
  CentralFacebookWebhookHealthRoute: CentralFacebookWebhookHealthRoute,
  CentralInstagramWebhookHealthRoute: CentralInstagramWebhookHealthRoute,
  CentralLanguagesRoute: CentralLanguagesRoute,
  CentralManualSubscriptionsRoute: CentralManualSubscriptionsRoute,
  CentralSubscriptionPlansRoute: CentralSubscriptionPlansRoute,
  CentralSubscriptionsRoute: CentralSubscriptionsRoute,
  CentralTranslationsRoute: CentralTranslationsRoute,
  CentralVendorsRoute: CentralVendorsRouteWithChildren,
  CentralWhatsappWebhookHealthRoute: CentralWhatsappWebhookHealthRoute,
  CentralIndexRoute: CentralIndexRoute,
}

const CentralRouteRouteWithChildren = CentralRouteRoute._addFileChildren(
  CentralRouteRouteChildren,
)

interface LegalRouteRouteChildren {
  LegalDataDeletionRoute: typeof LegalDataDeletionRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
}

const LegalRouteRouteChildren: LegalRouteRouteChildren = {
  LegalDataDeletionRoute: LegalDataDeletionRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
}

const LegalRouteRouteWithChildren = LegalRouteRoute._addFileChildren(
  LegalRouteRouteChildren,
)

interface VendorPagesRouteChildren {
  VendorPagesPageIdRoute: typeof VendorPagesPageIdRoute
}

const VendorPagesRouteChildren: VendorPagesRouteChildren = {
  VendorPagesPageIdRoute: VendorPagesPageIdRoute,
}

const VendorPagesRouteWithChildren = VendorPagesRoute._addFileChildren(
  VendorPagesRouteChildren,
)

interface VendorTeamRouteChildren {
  VendorTeamIndexRoute: typeof VendorTeamIndexRoute
}

const VendorTeamRouteChildren: VendorTeamRouteChildren = {
  VendorTeamIndexRoute: VendorTeamIndexRoute,
}

const VendorTeamRouteWithChildren = VendorTeamRoute._addFileChildren(
  VendorTeamRouteChildren,
)

interface VendorTemplatesNameRouteChildren {
  VendorTemplatesNameEditRoute: typeof VendorTemplatesNameEditRoute
}

const VendorTemplatesNameRouteChildren: VendorTemplatesNameRouteChildren = {
  VendorTemplatesNameEditRoute: VendorTemplatesNameEditRoute,
}

const VendorTemplatesNameRouteWithChildren =
  VendorTemplatesNameRoute._addFileChildren(VendorTemplatesNameRouteChildren)

interface VendorRouteRouteChildren {
  VendorCatalogRoute: typeof VendorCatalogRoute
  VendorChatRoute: typeof VendorChatRoute
  VendorConnectionTestRoute: typeof VendorConnectionTestRoute
  VendorConnectionsRoute: typeof VendorConnectionsRoute
  VendorContactGroupsRoute: typeof VendorContactGroupsRoute
  VendorCustomFieldsRoute: typeof VendorCustomFieldsRoute
  VendorLabelsRoute: typeof VendorLabelsRoute
  VendorNoActivePlanRoute: typeof VendorNoActivePlanRoute
  VendorOrdersRoute: typeof VendorOrdersRoute
  VendorPagesRoute: typeof VendorPagesRouteWithChildren
  VendorPaymentSuccessRoute: typeof VendorPaymentSuccessRoute
  VendorSetupRoute: typeof VendorSetupRoute
  VendorSubscriptionRoute: typeof VendorSubscriptionRoute
  VendorTeamRoute: typeof VendorTeamRouteWithChildren
  VendorIndexRoute: typeof VendorIndexRoute
  VendorCampaignsNewRoute: typeof VendorCampaignsNewRoute
  VendorCampaignsSuppressionRoute: typeof VendorCampaignsSuppressionRoute
  VendorContactsUidRoute: typeof VendorContactsUidRoute
  VendorContactsAutoLabelsRoute: typeof VendorContactsAutoLabelsRoute
  VendorContactsCrmRoute: typeof VendorContactsCrmRoute
  VendorContactsImportRoute: typeof VendorContactsImportRoute
  VendorFacebookInboxRoute: typeof VendorFacebookInboxRoute
  VendorFormsUidRoute: typeof VendorFormsUidRoute
  VendorGoogleReviewsRoute: typeof VendorGoogleReviewsRoute
  VendorInstagramAutomationsRoute: typeof VendorInstagramAutomationsRoute
  VendorInstagramInboxRoute: typeof VendorInstagramInboxRoute
  VendorInstagramSettingsRoute: typeof VendorInstagramSettingsRoute
  VendorIntegrationsApiRoute: typeof VendorIntegrationsApiRoute
  VendorIntegrationsConnectedAppsRoute: typeof VendorIntegrationsConnectedAppsRoute
  VendorIntegrationsEcommerceRoute: typeof VendorIntegrationsEcommerceRoute
  VendorIntegrationsGoogleRoute: typeof VendorIntegrationsGoogleRoute
  VendorIntegrationsMetaRoute: typeof VendorIntegrationsMetaRoute
  VendorSettingsAiAndTimingRoute: typeof VendorSettingsAiAndTimingRoute
  VendorSettingsFeaturesRoute: typeof VendorSettingsFeaturesRoute
  VendorSettingsGeneralRoute: typeof VendorSettingsGeneralRoute
  VendorSettingsRoutingRoute: typeof VendorSettingsRoutingRoute
  VendorTemplatesNameRoute: typeof VendorTemplatesNameRouteWithChildren
  VendorTemplatesNewRoute: typeof VendorTemplatesNewRoute
  VendorCampaignsIndexRoute: typeof VendorCampaignsIndexRoute
  VendorContactsIndexRoute: typeof VendorContactsIndexRoute
  VendorFormsIndexRoute: typeof VendorFormsIndexRoute
  VendorMediaIndexRoute: typeof VendorMediaIndexRoute
  VendorSettingsIndexRoute: typeof VendorSettingsIndexRoute
  VendorTemplatesIndexRoute: typeof VendorTemplatesIndexRoute
  VendorCampaignsUidEditRoute: typeof VendorCampaignsUidEditRoute
  VendorCampaignsUidStatusRoute: typeof VendorCampaignsUidStatusRoute
  VendorFacebookTemplatesNewRoute: typeof VendorFacebookTemplatesNewRoute
  VendorInstagramTemplatesNewRoute: typeof VendorInstagramTemplatesNewRoute
  VendorSettingsAiAgentsAgentIdRoute: typeof VendorSettingsAiAgentsAgentIdRoute
  VendorBotsFlowsIndexRoute: typeof VendorBotsFlowsIndexRoute
  VendorBotsRepliesIndexRoute: typeof VendorBotsRepliesIndexRoute
  VendorFacebookTemplatesIndexRoute: typeof VendorFacebookTemplatesIndexRoute
  VendorInstagramTemplatesIndexRoute: typeof VendorInstagramTemplatesIndexRoute
  VendorSettingsAiAgentsIndexRoute: typeof VendorSettingsAiAgentsIndexRoute
  VendorBotsFlowsFlowIdBuilderRoute: typeof VendorBotsFlowsFlowIdBuilderRoute
  VendorFacebookTemplatesUidEditRoute: typeof VendorFacebookTemplatesUidEditRoute
  VendorInstagramTemplatesUidEditRoute: typeof VendorInstagramTemplatesUidEditRoute
}

const VendorRouteRouteChildren: VendorRouteRouteChildren = {
  VendorCatalogRoute: VendorCatalogRoute,
  VendorChatRoute: VendorChatRoute,
  VendorConnectionTestRoute: VendorConnectionTestRoute,
  VendorConnectionsRoute: VendorConnectionsRoute,
  VendorContactGroupsRoute: VendorContactGroupsRoute,
  VendorCustomFieldsRoute: VendorCustomFieldsRoute,
  VendorLabelsRoute: VendorLabelsRoute,
  VendorNoActivePlanRoute: VendorNoActivePlanRoute,
  VendorOrdersRoute: VendorOrdersRoute,
  VendorPagesRoute: VendorPagesRouteWithChildren,
  VendorPaymentSuccessRoute: VendorPaymentSuccessRoute,
  VendorSetupRoute: VendorSetupRoute,
  VendorSubscriptionRoute: VendorSubscriptionRoute,
  VendorTeamRoute: VendorTeamRouteWithChildren,
  VendorIndexRoute: VendorIndexRoute,
  VendorCampaignsNewRoute: VendorCampaignsNewRoute,
  VendorCampaignsSuppressionRoute: VendorCampaignsSuppressionRoute,
  VendorContactsUidRoute: VendorContactsUidRoute,
  VendorContactsAutoLabelsRoute: VendorContactsAutoLabelsRoute,
  VendorContactsCrmRoute: VendorContactsCrmRoute,
  VendorContactsImportRoute: VendorContactsImportRoute,
  VendorFacebookInboxRoute: VendorFacebookInboxRoute,
  VendorFormsUidRoute: VendorFormsUidRoute,
  VendorGoogleReviewsRoute: VendorGoogleReviewsRoute,
  VendorInstagramAutomationsRoute: VendorInstagramAutomationsRoute,
  VendorInstagramInboxRoute: VendorInstagramInboxRoute,
  VendorInstagramSettingsRoute: VendorInstagramSettingsRoute,
  VendorIntegrationsApiRoute: VendorIntegrationsApiRoute,
  VendorIntegrationsConnectedAppsRoute: VendorIntegrationsConnectedAppsRoute,
  VendorIntegrationsEcommerceRoute: VendorIntegrationsEcommerceRoute,
  VendorIntegrationsGoogleRoute: VendorIntegrationsGoogleRoute,
  VendorIntegrationsMetaRoute: VendorIntegrationsMetaRoute,
  VendorSettingsAiAndTimingRoute: VendorSettingsAiAndTimingRoute,
  VendorSettingsFeaturesRoute: VendorSettingsFeaturesRoute,
  VendorSettingsGeneralRoute: VendorSettingsGeneralRoute,
  VendorSettingsRoutingRoute: VendorSettingsRoutingRoute,
  VendorTemplatesNameRoute: VendorTemplatesNameRouteWithChildren,
  VendorTemplatesNewRoute: VendorTemplatesNewRoute,
  VendorCampaignsIndexRoute: VendorCampaignsIndexRoute,
  VendorContactsIndexRoute: VendorContactsIndexRoute,
  VendorFormsIndexRoute: VendorFormsIndexRoute,
  VendorMediaIndexRoute: VendorMediaIndexRoute,
  VendorSettingsIndexRoute: VendorSettingsIndexRoute,
  VendorTemplatesIndexRoute: VendorTemplatesIndexRoute,
  VendorCampaignsUidEditRoute: VendorCampaignsUidEditRoute,
  VendorCampaignsUidStatusRoute: VendorCampaignsUidStatusRoute,
  VendorFacebookTemplatesNewRoute: VendorFacebookTemplatesNewRoute,
  VendorInstagramTemplatesNewRoute: VendorInstagramTemplatesNewRoute,
  VendorSettingsAiAgentsAgentIdRoute: VendorSettingsAiAgentsAgentIdRoute,
  VendorBotsFlowsIndexRoute: VendorBotsFlowsIndexRoute,
  VendorBotsRepliesIndexRoute: VendorBotsRepliesIndexRoute,
  VendorFacebookTemplatesIndexRoute: VendorFacebookTemplatesIndexRoute,
  VendorInstagramTemplatesIndexRoute: VendorInstagramTemplatesIndexRoute,
  VendorSettingsAiAgentsIndexRoute: VendorSettingsAiAgentsIndexRoute,
  VendorBotsFlowsFlowIdBuilderRoute: VendorBotsFlowsFlowIdBuilderRoute,
  VendorFacebookTemplatesUidEditRoute: VendorFacebookTemplatesUidEditRoute,
  VendorInstagramTemplatesUidEditRoute: VendorInstagramTemplatesUidEditRoute,
}

const VendorRouteRouteWithChildren = VendorRouteRoute._addFileChildren(
  VendorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  CentralRouteRoute: CentralRouteRouteWithChildren,
  LegalRouteRoute: LegalRouteRouteWithChildren,
  VendorRouteRoute: VendorRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  FeaturesRoute: FeaturesRoute,
  PricingRoute: PricingRoute,
  DeletionStatusCodeRoute: DeletionStatusCodeRoute,
  PageSlugRoute: PageSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
